export function isAcceptedField(field) {
  // Certain extraction results can be accepted in memory before operator review.
  // The result-file A state is the durable marker that the field was accepted.
  return field?.validationInfo?.isAccepted === true
    && field?.Entries?.[0]?.State?.includes('A') === true;
}

export function getFieldBorderColor(field, palette) {
  if (field?.validationInfo?.isRejected) return palette.error.main;
  if (field?.isReadOnly) return palette.grey[700];
  if (isAcceptedField(field)) return palette.success.main;
  if (field?.validationInfo?.isRequired) return palette.status.review[palette.mode];
  return palette.status.certain.main;
}
